import { render, staticRenderFns } from "./bimTextH1.vue?vue&type=template&id=3d31d668&scoped=true&lang=html&"
import script from "./bimTextH1.vue?vue&type=script&lang=js&"
export * from "./bimTextH1.vue?vue&type=script&lang=js&"
import style0 from "./bimTextH1.vue?vue&type=style&index=0&id=3d31d668&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d31d668",
  null
  
)

export default component.exports